import { PIMSProduct, VetCorProduct, VetCorProductCategory } from '../shared/services/ppv.api'
import { TreeNode } from 'primeng/api'

export type VetCorProductCategoryHierarchical = VetCorProductCategory & {
   childCategories: VetCorProductCategoryHierarchical[]
   products: VetCorProduct[]
}

export class ProductFunctions {
   static findAndExpandCollapse(tree: TreeNode, selectedValue: any, expandCollapse?: boolean) {
      if (!tree) return undefined
      if (selectedValue && tree.key === '' + selectedValue) return tree
      let found = undefined
      if (tree.children && tree.children.length) {
         for (const node of tree.children) {
            found = this.findAndExpandCollapse(node, selectedValue, expandCollapse) || found
         }
      }
      if (expandCollapse && !!found) tree.expanded = true
      return found
   }

   static getPIMSTreeSelectProducts(products: PIMSProduct[]): TreeNode[] {
      const lookup = {}
      products.forEach((prod) => {
         lookup[prod.categoryName] = lookup[prod.categoryName] || []
         lookup[prod.categoryName].push(<TreeNode>{
            label: prod.name + ` (${(prod.revenuePercent * 100).toFixed(2)}% Rev)`,
            selectable: true,
            data: prod.productSKey,
            key: '' + prod.productSKey,
         })
      })
      const retval = []
      Object.keys(lookup).forEach((cname) => {
         retval.push(<TreeNode>{
            label: cname,
            selectable: false,
            children: lookup[cname].sort((a, b) => a.label.localeCompare(b.label)),
            data: { categoryName: cname },
            expanded: false,
            key: 'c' + cname,
         })
      })

      return retval.sort((a, b) => a.label.localeCompare(b.label))
   }

   static getTreeSelectProducts(
      products: VetCorProduct[],
      categories: VetCorProductCategory[],
      addMappedPercentage: boolean,
      addCode: boolean = false
   ): TreeNode[] {
      const categoryLookup = {}
      const categoriesByParentLookup: { [key: number]: VetCorProductCategory[] } = {}
      const productsCatLookup: { [categorySKey: number]: VetCorProduct[] } = {}

      categories.forEach((cat) => {
         categoryLookup[cat.vcProductCategorySKey] = cat
         productsCatLookup[cat.vcProductCategorySKey] = []

         if (cat.parentVCProductCategorySKey) {
            if (!categoriesByParentLookup[cat.parentVCProductCategorySKey]) categoriesByParentLookup[cat.parentVCProductCategorySKey] = []

            categoriesByParentLookup[cat.parentVCProductCategorySKey].push(cat)
         }
      })

      products.forEach((prod) => productsCatLookup[prod.vcProductCategorySKey]?.push(prod))

      // PARENT PROPERTY IS BUSTED - DONT WASTE YOUR TIME!
      function buildTreeNode(cat: VetCorProductCategory): TreeNode {
         const children: TreeNode[] = []

         const treeNode: TreeNode = {
            label: cat.name,
            selectable: false,
            data: cat,
            key: 'c' + cat.vcProductCategorySKey,
         }

         const childCategories = categoriesByParentLookup[cat.vcProductCategorySKey]
         if (!!childCategories) childCategories.sort((a, b) => a.name.localeCompare(b.name)).forEach((child) => children.push(buildTreeNode(child)))

         const childProducts = productsCatLookup[cat.vcProductCategorySKey]
         if (!!childProducts)
            childProducts
               .sort((a, b) => a.name.localeCompare(b.name))
               .forEach((prod) =>
                  children.push(<TreeNode>{
                     label:
                        prod.name +
                        (addMappedPercentage ? ` (${(prod.mappedPracticePercentage * 100).toFixed(2)}% Mapped)` : '') +
                        (addCode ? ' - ' + prod.vcProductSKey : ''),
                     selectable: true,
                     data: prod,
                     key: '' + prod.vcProductSKey,
                  })
               )

         treeNode.children = children

         return treeNode
      }

      const sortArray = {
         Service: 0,
         Item: 1,
         Ancillary: 2,
         Miscellaneous: 3,
      }

      const topTreeNodes = categories
         .filter((cat) => !cat.parentVCProductCategorySKey)
         .map((cat) => buildTreeNode(cat))
         .sort((a, b) => {
            if (sortArray[a.label] === sortArray[b.label]) return a.label?.localeCompare(b.label)

            return sortArray[a.label] - sortArray[b.label]
         })

      return topTreeNodes
   }
}
